import { Routes, Route } from "react-router-dom";
import "./App.css";
import Loading from "./pages/Loading";
import Dashboard from "./pages/Dashboard";
import Layout from "./component/layout/Layout";
import Chooseround from "./pages/Chooseround";
import Playlottery from "./pages/Playlottery";
import Historylottery from "./pages/Historylottery";
import Resultlottery from "./pages/Resultlottery";
import Betnumset from "./pages/Betnumset";
import Buylottery from "./pages/Buylottery";
import Checkout from "./pages/Checkout";
import InvoiceInfomation from "./pages/InvoiceInfomation";
import PageNoteFound from "./pages/404";
import SetNumber from "./pages/SetNumber";
import { PrintButton } from "./component/PrintButton";

function App() {
  return (
    <div className="bg-[#ffffff] min-h-screen h-full font-display">
      <Routes>
        {/* <Route path="/" element={<FakeLogin />} /> */}
        {/* <Route path="/fakeLogin" element={<FakeLogin />} /> */}
        <Route path="/loading" element={<Loading />} />
        <Route path="*" element={<PageNoteFound />} />
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/chooseround" element={<Chooseround />} />
          <Route path="/buylottery" element={<Buylottery />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/playlottery" element={<Playlottery />} />
          <Route path="/historylottery" element={<Historylottery />} />
          <Route path="/invoiceinfomation/:ref" element={<InvoiceInfomation />} />
          <Route path="/invoiceinfomation" element={<InvoiceInfomation />} />
          <Route path="/previewprint" element={<PrintButton />} />
          <Route path="/resultlottery" element={<Resultlottery />} />
          <Route path="/betnumset" element={<Betnumset />} />
          <Route path="/setnumber" element={<SetNumber />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
